import { z } from 'zod';
import { Email, Id, Timestamp, Uri } from './common.js';

export const User = z.object({
  id: Id,
  email: Email,
  display_name: z.string().max(120),
  avatar_url: Uri.nullable().optional(),
  email_verified: z.boolean(),
  has_password: z.boolean().optional(),
  created_at: Timestamp,
  last_login_at: Timestamp.nullable().optional(),
});
export type User = z.infer<typeof User>;
